// label for React Select dropdowns
// TODO: consolidate with /src/components/Label/Label.jsx?
const SelectLabel = ({
  id,
  children,
  style,
}) => {
  return <label
    className="bx--label"
    style={{...style}}
    id={id}
    htmlFor={id}
  >
    {children}
  </label>
}

export default SelectLabel